export default __webpack_public_path__ + "static/media/de_ad_banner.f0a48d4a.png";